import React, { useEffect } from 'react';
import './LessonNav.scss';
import CustomBtn from '../../../../components/CustomBtn/CustomBtn';
import SvgIcons from '../../../../services/SvgIcons';
import { updateVisibleChapters, handleLessonClick, toggleChapterVisibility, navigateToPreviousLesson, navigateToNextLesson } from '../../utils/lessonUtils';
import Skeleton from '../../../../components/Skeleton/Skeleton';
import ProgressBar from '../../../../components/ProgressBar/ProgressBar';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';
import BackgroundImageWithSkeleton from '../../../../components/BackgroundImageWithSkeleton/BackgroundImageWithSkeleton';

export default function LessonNav(
    {
        trainingDetails,
        displayedMobileMenu,
        setDisplayedMobileMenu,
        selectedTrainingChapter,
        setSelectedTrainingChapter,
        selectedTrainingLesson,
        setSelectedTrainingLesson,
        contentRef,
        titleRef,
        visibleChapters,
        setVisibleChapters,
        isMobile,
        trainingProgress,
        setTrainingProgress,
        completedLessons,
        setCompletedLessons,
        setError
    }) {

    // Mettre à jour les chapitres visibles en fonction de la leçon sélectionnée
    useEffect(() => {
        if (selectedTrainingChapter && selectedTrainingLesson) {
            updateVisibleChapters(trainingDetails, selectedTrainingChapter.id, setVisibleChapters);
        }
    }, [selectedTrainingChapter, selectedTrainingLesson, trainingDetails, setVisibleChapters]);

    console.log('completedLessons:', completedLessons);
    console.log('trainingDetails in LessonNav:', trainingDetails);
    console.log('trainingProgress in LessonNav:', trainingProgress);

    // Plus besoin de charger séparément la progression car elle est incluse dans trainingDetails
    // L'effet a été supprimé car la progression est maintenant chargée directement dans TrainingDetailsPage

    return (
        <div className={`training-lesson-nav ${displayedMobileMenu ? 'active' : ''}`}>
            <div className='training-lesson-nav__header'>
                {
                    trainingDetails.title ?
                        <>
                            {
                                trainingDetails.photoCard ?
                                    <BackgroundImageWithSkeleton
                                        picture={trainingDetails.photoCard}
                                        width={'160px'}
                                        height={'80px'}
                                        positionMobile='static'
                                        positionDesktop='static'
                                        borderRadius='10px'
                                    />
                                    :
                                    <Skeleton
                                        width="160px"
                                        height="80px"
                                        borderRadius="10px"
                                        bkgColor="#EEE6DB"
                                        animColor="#F5F0ED"
                                    />
                            }
                            <span className='training-lesson-nav__title'>{trainingDetails.title}</span>
                        </>
                    :
                        <>
                            <Skeleton
                                width='160px'
                                height={'80px'}
                                borderRadius='10px'
                                bkgColor='#EEE6DB'
                                animColor='#F5F0ED'
                                margin='0'
                            />
                            <Skeleton
                                width='90%'
                                height={'36px'}
                                borderRadius='24px'
                                bkgColor='#EEE6DB'
                                animColor='#F5F0ED'
                                margin='0'
                            />
                        </>
                }
                <div className='training-lesson-nav__btn_container'>
                    {
                        trainingDetails.id ?
                            <>
                                <CustomBtn
                                    type={'action'}
                                    title={"Précédent"}
                                    on_click={
                                        () => navigateToPreviousLesson(
                                            selectedTrainingChapter,
                                            selectedTrainingLesson,
                                            trainingDetails,
                                            (chapter, lesson) => handleLessonClick(
                                                trainingDetails,
                                                chapter,
                                                lesson,
                                                setSelectedTrainingChapter,
                                                setSelectedTrainingLesson,
                                                updateVisibleChapters,
                                                setVisibleChapters,
                                                setDisplayedMobileMenu,
                                                contentRef,
                                                titleRef,
                                                isMobile
                                            )
                                        )
                                    }
                                    bkg_color={'transparent'}
                                    bkg_color_hover={'#EEE6DB'}
                                    text_color={'#361215'}
                                    text_color_hover={'#361215'}
                                    border_color={'#361215'}
                                    border_color_hover={'#361215'}
                                    font_family={'Playfair Display, serif'}
                                    font_size={'18px'}
                                    border_radius={'5px'}
                                    width={'130px'}
                                    height={'42px'}
                                    opacity={selectedTrainingChapter && selectedTrainingChapter.order_nb === 1 && selectedTrainingLesson && selectedTrainingLesson.order_nb === 1 ? 0.2 : 1}
                                    isSmallMobileBut={true}
                                />
                                <CustomBtn
                                    type={'action'}
                                    title={"Suivant"}
                                    on_click={
                                        () => navigateToNextLesson(
                                            selectedTrainingChapter,
                                            selectedTrainingLesson,
                                            trainingDetails,
                                            (chapter, lesson) => handleLessonClick(
                                                trainingDetails,
                                                chapter,
                                                lesson,
                                                setSelectedTrainingChapter,
                                                setSelectedTrainingLesson,
                                                updateVisibleChapters,
                                                setVisibleChapters,
                                                setDisplayedMobileMenu,
                                                contentRef,
                                                titleRef,
                                                isMobile
                                            )
                                        )
                                    }
                                    bkg_color={'#361215'}
                                    bkg_color_hover={'#EEE6DB'}
                                    text_color={'#EEE6DB'}
                                    text_color_hover={'#361215'}
                                    border_color={'#361215'}
                                    border_color_hover={'#361215'}
                                    font_family={'Playfair Display, serif'}
                                    font_size={'18px'}
                                    border_radius={'5px'}
                                    width={'130px'}
                                    height={'42px'}
                                    opacity={selectedTrainingChapter && selectedTrainingChapter.order_nb === trainingDetails.chapters?.length && selectedTrainingLesson && selectedTrainingLesson.order_nb === selectedTrainingChapter.lessons?.length ? 0.2 : 1}
                                    isSmallMobileBut={true}
                                />
                            </>
                        :
                            <>
                                <Skeleton
                                    width='130px'
                                    height='49px'
                                    borderRadius='5px'
                                    bkgColor='#EEE6DB'
                                    animColor='#F5F0ED'
                                />
                                <Skeleton
                                    width='130px'
                                    height='49px'
                                    borderRadius='5px'
                                    bkgColor='#EEE6DB'
                                    animColor='#F5F0ED'
                                />
                            </>

                    }
                </div>
                <div className='training-lesson-nav__progress'>
                    {
                        trainingDetails.id ?
                            <ProgressBar progress={trainingProgress} />
                        :
                            <Skeleton
                                width='100%'
                                height='24px'
                                borderRadius='12px'
                                bkgColor='#EEE6DB'
                                animColor='#F5F0ED'
                                margin='1rem 0'
                            />
                    }
                </div>
            </div>
            <div className='training-lesson-nav__menu'>
                {
                    trainingDetails.chapters ?
                        <ul className='training-lesson-nav__chapters_list'>
                            {
                                trainingDetails.chapters &&
                                trainingDetails.chapters.map((chapter) => (
                                    <li key={chapter.id} className='training-lesson-nav__chapter'>
                                        <div
                                            className={`training-lesson-nav__chapter_title_container ${selectedTrainingChapter?.id === chapter.id ? 'active' : ''}`}
                                            onClick={() => toggleChapterVisibility(chapter.id, setVisibleChapters)}
                                        >
                                            <SvgIcons
                                                name='chevron_back'
                                                width={15}
                                                height={15}
                                                color='#361215'
                                                strokeWidth={'80px'}
                                                transform={visibleChapters[chapter.id] ? 'rotate(90deg)' : 'rotate(-90deg)'}
                                                transition={'500ms transform ease-in'}
                                            />
                                            <span className='training-lesson-nav__chapter_title'>{chapter.title}</span>
                                        </div>
                                        <ul className={`training-lesson-nav__lessons_list ${visibleChapters[chapter.id] ? 'open' : ''}`}>
                                            {
                                                chapter.lessons &&
                                                chapter.lessons.map((lesson) => (
                                                    <li
                                                        key={lesson.id}
                                                        className='training-lesson-nav__lesson'
                                                        onClick={() => handleLessonClick(trainingDetails, chapter, lesson, setSelectedTrainingChapter, setSelectedTrainingLesson, updateVisibleChapters, setVisibleChapters, setDisplayedMobileMenu, contentRef, titleRef, isMobile)}
                                                    >
                                                        <div className={`training-lesson-nav__lesson_title_container ${selectedTrainingLesson?.id === lesson.id ? 'active' : ''}`}>
                                                            <SvgIcons
                                                                name={completedLessons[`${chapter.order_nb}-${lesson.order_nb}`] ? 'check_circle' : 'empty_circle'}
                                                                width={15}
                                                                height={15}
                                                                color={selectedTrainingLesson?.id === lesson.id ? '#E6CAA3' : '#361215'}
                                                                strokeWidth={'50px'}
                                                            />
                                                            <span className={`training-lesson-nav__lesson_title ${selectedTrainingLesson?.id === lesson.id ? 'active' : ''}`}>{lesson.title}</span>
                                                        </div>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </li>
                                ))
                            }
                        </ul>
                    :
                        <Skeleton
                            width='100%'
                            height={isMobile ? 'calc(100vh - 430px)' : 'calc(100vh - 877px)'}
                            borderRadius='1rem'
                            bkgColor='#EEE6DB'
                            animColor='#F5F0ED'
                            margin='0'
                        />
                }
            </div>
        </div>
    );
}